import * as React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import NewPersonForm from "./components/NewPersonForm/NewPersonForm";
import UserAccess from "./components/UserAccess/UserAccess";
import Dashboard from "./components/Dashboard/Dashboard";
import { locStor } from "./services/localStorageManipulation";
import { USER_APIKEY } from "./services/constants";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import { SnackbarProvider, closeSnackbar } from "notistack";

import { IconButton, CssBaseline } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Map from "./components/Map/Map";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#68bcbc",
      dark: "#68bcbc",
      // dark: "#3a4e81",
      // dark: "#253461",
    },
  },
});

// const currentScreen = ["userAccess", "dashboard", "map"]

const App = () => {
  const [currentPage, setCurrentPage] = React.useState("Home");
  // const [userData, setUserData] = React.useState(locStor.get(USER_DATA));
  const [userApiKey, setUserApiKey] = React.useState(locStor.get(USER_APIKEY));
  const [openPersonForm, setOpenPersonForm] = React.useState(false);
  const [needRefreshData, setRefreshData] = React.useState(0);


  const setNeedRefreshData = ()=>{
    setRefreshData(needRefreshData+1)
  }
  const displayPersonForm = (newState) => {
    setOpenPersonForm(newState);
  };

  const notFoundElem = () => {
    return <>Not Found or Page not created yet</>;
  };

  const setApiKeyHandler = (apikeyParam) => {
    locStor.set(USER_APIKEY, apikeyParam);
    setUserApiKey(apikeyParam);
  };
  // setInterval(()=>{
  //   setNeedRefreshData();
  // }, 10000)

  return (
    <Provider store={store}>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <LoadingScreen />
        <SnackbarProvider
          autoHideDuration={3500}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          action={(snackbarId) => (
            <IconButton
              aria-label="close notification"
              onClick={() => closeSnackbar(snackbarId)}
            >
              <CloseIcon />
            </IconButton>
          )}
        >
          <BrowserRouter>
            <Navbar
              currentPage={currentPage}
              displayPersonForm={displayPersonForm}
              changePage={setCurrentPage}
            ></Navbar>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <UserAccess
                      setApiKey={setApiKeyHandler}
                      changePage={setCurrentPage}
                    />
                  </>
                }
              />
              <Route
                path="/index.html"
                element={
                  <>
                    <UserAccess
                      setApiKey={setApiKeyHandler}
                      changePage={setCurrentPage}
                    />
                  </>
                }
              />
              <Route
                path="/access"
                element={
                  <>
                    <UserAccess
                      setApiKey={setApiKeyHandler}
                      changePage={setCurrentPage}
                    />
                  </>
                }
              />

              <Route
                path="/dashboard"
                element={
                  <>
                    <Dashboard
                      userApiKey={userApiKey}
                      needRefreshData={needRefreshData}
                      setNeedRefreshData={setNeedRefreshData}
                    ></Dashboard>
                    <NewPersonForm
                      setNeedRefreshData={setNeedRefreshData}
                      isOpen={openPersonForm}
                      setOpen={displayPersonForm}
                    ></NewPersonForm>
                  </>
                }
              />
              <Route
                path="/map"
                element={
                  <>
                    <Map userApiKey={userApiKey}/>
                  </>
                }
              />

              <Route path="*" element={notFoundElem()} />
            </Routes>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
